<script>
export default {
  props: {
    name: { type: String, required: true },
    saveFunc: { type: Function, required: true },
    htmlWarningFromDataFunc: { type: Function, required: true },
  },

  data: function () {
    return {
      busySaving: false,
      rawData: '',
      htmlWarning: '',
    }
  },

  watch: {
    rawData(to) {
      this.htmlWarning = this.htmlWarningFromDataFunc(to);
    },
  },

  methods: {
    async save() {
      this.busySaving = true;
      try {
        await this.saveFunc(this.rawData);
        alert('Successfully imported');
        this.rawData = '';
      } finally {
        this.busySaving = false;
      }
    },
  },

}
</script>

<template>
  <div>
    <textarea v-model="rawData" rows="20" max-rows="50" class="w-100 small"></textarea>

    <b-alert show variant="danger" class="mt-5">
      <div>
        <i class="fa fa-warning"></i>
        This operation is dangerous and cannot be undone.
        <span v-html="htmlWarning"></span>
      </div>

      <div class="d-flex">
        <confirm-click>
          <button @click="save" class="btn btn-danger mx-auto mt-3" :disabled="rawData&&busySaving">
            <i v-if="busySaving" class="fa fa-spinner fa-spin"></i>
            <i v-else class="fa fa-warning"></i>
            Import {{name}}
          </button>
        </confirm-click>
      </div>
    </b-alert>
  </div>
</template>



// WEBPACK FOOTER //
// src/dataAdmin/components/ImportSpecificData.vue